// Baseroutes
export const PAGE = "/:slug?";

// Meta Routes
export const IMPRINT = "/imprint";
export const PRIVACY = "/privacy";

// Base URL
// eslint-disable-next-line prefer-destructuring
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
